import { ChevronDown } from "lucide-react";
import React from "react";

interface ChainSwitchProps {
  onClick: () => void;
  chain: any;
  logoURI: string;
}
const ChainSwitch: React.FC<ChainSwitchProps> = ({
  onClick,
  logoURI,
  chain,
}) => {
  console.log(chain, logoURI);
  return (
    <div
      role="button"
      onClick={onClick}
      className="flex cursor-pointer lg:gap-x-1.25 gap-x-0.5 items-center "
    >
      {chain ? (
        <img src={logoURI} className="h-5 rounded-full w-5 " />
      ) : (
        <h1 className="font-redhat-display font-bold lg:text-xs text-[10px]">
          Chain
        </h1>
      )}
      <ChevronDown className="sm:h-6 h-5 sm:w-6 w-5 cursor-pointer" />
    </div>
  );
};

export default ChainSwitch;
